import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import air_logo from '../../../../common/images/air_logo.png';
import './HeaderBrandArea.css';

@withRouter
export default class HeaderBrandArea extends Component {
  render() {
    return (
      <div
        className="HeaderBrandArea"
        onClick={() => {
          this.props.history.push('/dashboard');
        }}
      >
        <div>
          <img src={air_logo} alt="air logo" />
        </div>
        <h2>MyFleet</h2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Header/HeaderBrandArea/HeaderBrandArea.js